export default "__VITE_ASSET__bd39b94a__"